import React, { useEffect, useState } from "react";


export default function SymptomManager() {
  const [search, setSearch] = useState("");
  const [symptoms, setSymptoms] = useState([]);
  const [page, setPage] = useState(1);
  const pageSize = 20;
  const totalPages = Math.ceil(symptoms.length / pageSize);
  const [form, setForm] = useState({ name: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [editId, setEditId] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    setFetching(true);
    fetch(`${process.env.REACT_APP_API_BASE_URL}/symptoms/`)
      .then(res => res.json())
      .then(data => setSymptoms(data))
      .catch(() => setSymptoms([]))
      .finally(() => setFetching(false));
  }, []);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleAdd = async e => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/symptoms/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form)
      });
      if (!res.ok) throw new Error("Failed to add symptom");
      const newSymptom = await res.json();
      setSymptoms([...symptoms, newSymptom]);
      setForm({ name: "" });
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  const handleDelete = async _id => {
    if (!window.confirm("Delete this symptom?")) return;
    await fetch(`${process.env.REACT_APP_API_BASE_URL}/symptoms/inactivate/${_id}`, { method: "PUT" });
    setSymptoms(symptoms.filter(s => s._id !== _id));
  };

  const handleEdit = _id => {
    setEditId(_id);
    const symptom = symptoms.find(s => s._id === _id);
    setEditValue(symptom ? symptom.name : "");
  };

  const handleUpdate = async _id => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/symptoms/${_id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: editValue })
      });
      if (!res.ok) throw new Error("Failed to update symptom");
      setSymptoms(symptoms.map(s => s._id === _id ? { ...s, name: editValue } : s));
      setEditId(null);
      setEditValue("");
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div>
      {(loading || fetching) && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(255,255,255,0.7)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div className="spinner-border text-primary" style={{width: '3rem', height: '3rem'}} role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <h5>Add Symptom</h5>
      <form className="row g-2 mb-3" onSubmit={handleAdd}>
        <div className="col-md-10">
          <input name="name" value={form.name} onChange={handleChange} className="form-control" placeholder="Symptom Name" required />
        </div>
        <div className="col-md-2">
          <button className="btn btn-primary w-100" type="submit" disabled={loading}>Add</button>
        </div>
        {error && <div className="col-12 text-danger">{error}</div>}
      </form>
      <h5>Symptoms List</h5>
      <div className="mb-2">
        <input type="text" className="form-control" placeholder="Search symptoms..." value={search || ''} onChange={e => setSearch(e.target.value)} />
      </div>
      <div className="table-responsive w-100">
        <table className="table table-bordered w-100">
          <thead><tr><th>Name</th><th>HPO ID</th><th>Actions</th></tr></thead>
          <tbody>
            {symptoms.filter(s => {
              if (!search) return true;
              const val = search.toLowerCase();
              return (s.name?.toLowerCase().includes(val) || s.hpoId?.toLowerCase().includes(val));
            }).slice((page-1)*pageSize, page*pageSize).map(s => (
              <tr key={s._id}>
                <td>
                  {editId === s._id ? (
                    <input value={editValue} onChange={e => setEditValue(e.target.value)} className="form-control" />
                  ) : (
                    s.name
                  )}
                </td>
                <td>{s.hpoId || '-'}</td>
                <td>
                  {editId === s._id ? (
                    <>
                      <span style={{cursor:'pointer',marginRight:'12px'}} title="Save">
                        <i className="mdi mdi-check" onClick={() => handleUpdate(s._id)}></i>
                      </span>
                      <span style={{cursor:'pointer'}} title="Cancel">
                        <i className="mdi mdi-close" onClick={() => setEditId(null)}></i>
                      </span>
                    </>
                  ) : (
                    <>
                      <span style={{cursor:'pointer',marginRight:'12px'}} title="Edit">
                        <i className="mdi mdi-pencil" onClick={() => handleEdit(s._id)}></i>
                      </span>
                      <span style={{cursor:'pointer'}} title="Delete">
                        <i className="mdi mdi-delete" onClick={() => handleDelete(s._id)}></i>
                      </span>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="d-flex justify-content-end align-items-center mt-2 gap-2">
            <button className="btn btn-outline-secondary btn-sm" disabled={page===1} onClick={()=>setPage(page-1)}>Prev</button>
            <span>Page {page} of {totalPages}</span>
            <button className="btn btn-outline-secondary btn-sm" disabled={page===totalPages} onClick={()=>setPage(page+1)}>Next</button>
          </div>
        )}
      </div>
    </div>
  );
}
